import React, { useEffect, useState } from 'react';
import CardAccordion from '../../../Components/Form/Buttons/Accordions/CardAccordion';
import TextInput from '../../../Components/Form/Inputs/TextInput';
import RegexValidators from '../../../Core/Validation/RegexValidators';
import useLanguage from '../../../Services/Language/useLanguageHook';
import styles from '../ChartBuilder.module.scss';
import { ChartBuilderRequest, defaultLabels } from '../ChartBuilderDefinitions';

interface IChartBuilderLabelOptionsProps {
    chartBuilderRequest: ChartBuilderRequest;
    setChartBuilderRequest: (chartBuilderRequest: ChartBuilderRequest) => void;
}

// TODO: Will use backend options for these labels.
const ChartBuilderLabelOptions: React.FC<IChartBuilderLabelOptionsProps> = (props: IChartBuilderLabelOptionsProps) => {
    const [translations] = useLanguage();

    const [labelValue1, setLabelValue1] = useState(props.chartBuilderRequest?.labels![0] ?? '');
    const [labelValue2, setLabelValue2] = useState(props.chartBuilderRequest?.labels![1] ?? '');

    useEffect(() => {
        let labels = [...defaultLabels];
        if (Array.isArray(props.chartBuilderRequest.labels)) {
            labels = props.chartBuilderRequest.labels;
        }

        props.setChartBuilderRequest({
            ...props.chartBuilderRequest,
            labels: labels?.map((x, index) => (index === 0 ? labelValue1 : labelValue2)),
        });
    }, [labelValue1, labelValue2]);

    return (
        <CardAccordion
            type="gray"
            title={
                <p className={styles.chart_builder_labels_optional_text}>
                    <p>{translations.chartBuilder.headers.labels}</p>
                    <p className={styles.chart_builder_optional_text}>{`(${translations.chartBuilder.headers.labelsOptional})`}</p>
                </p>
            }
            component={
                <>
                    <div className={styles.chart_builder_row}>
                        <TextInput
                            title={translations.chartBuilder.fields.axisOneLabel}
                            value={labelValue1}
                            handleTextChange={(value) => setLabelValue1(value)}
                            validation={RegexValidators.AlphaNumericMinimumLength2}
                            track={{
                                eventCategory: 'ChartBuilder',
                                eventAction: 'Axis1LabelChange',
                                eventValue: labelValue1,
                            }}
                        />
                    </div>
                    <div className={styles.chart_builder_row}>
                        <TextInput
                            title={translations.chartBuilder.fields.axisTwoLabel}
                            value={labelValue2}
                            handleTextChange={(value) => setLabelValue2(value)}
                            validation={RegexValidators.AlphaNumericMinimumLength2}
                            track={{
                                eventCategory: 'ChartBuilder',
                                eventAction: 'Axis2LabelChange',
                                eventValue: labelValue2,
                            }}
                        />
                    </div>
                </>
            }
        />
    );
};

export default ChartBuilderLabelOptions;
